import React, { memo, useEffect, useRef } from 'react';
import { getCreateAccountObject } from '../utils/guidedUtil';
import GlobalModal from '../../global/atoms/globalModal/GlobalModal';
import { AEM_CONTAINS_PHONE_NUMBER, AEM_CONTAINS_EMAIL } from '../constants';
import { useAnalyticsContext } from '../../../config/GoogleTagManagerEvents';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../constants/analyticsConstants/Ecommerce';
import './joinAccountModal.scss';
import { convertPhoneNumberAsPerSbmChannel } from '../../global/utils/commonUtils';

const JoinAccount = props => {
    const { showJoinAccountModal, setShowJoinAccountModal } = props;
    const createAccountScreenConfigs = getCreateAccountObject();
    const {
        joinAccountTitle = '',
        joinAccountDescription = '',
        phoneNumberField = '',
        emailField = ''
    } = createAccountScreenConfigs || {};
    const { sendEventsForGRModalOpened, sendEventsForModalClosed, sendEventsForGRModalCTAClicked } =
        useAnalyticsContext();

    const descriptionRef = useRef(null);

    const phoneNumber = convertPhoneNumberAsPerSbmChannel(phoneNumberField);

    useEffect(() => {
        if (showJoinAccountModal) {
            sendEventsForGRModalOpened(
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_VIEWED,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_MODAL_JOIN_ACCOUNT,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
                ''
            );
        }
    }, [showJoinAccountModal]);

    const handleOnAfterOpen = () => {
        if (descriptionRef) {
            const descriptionElement = descriptionRef?.current;
            const emailLink = descriptionElement?.querySelector('.join-account__email');
            const phoneLink = descriptionElement?.querySelector('.join-account__phone');

            const handleClick = event => {
                const type = event.currentTarget.classList.contains('join-account__email') ? 'email' : 'phone';
                sendClickEvent(type);
            };
            emailLink?.addEventListener('click', handleClick);
            phoneLink?.addEventListener('click', handleClick);
        }
    };

    const sendClickEvent = type => {
        sendEventsForGRModalCTAClicked(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CTA_CLICKED,
            type,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_BUTTON,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_MODAL,
            `#${type}`
        );
    };

    const modalDescription = (
        <p
            ref={descriptionRef}
            className="join-account__description"
            dangerouslySetInnerHTML={{
                __html: joinAccountDescription
                    ?.replace(
                        AEM_CONTAINS_EMAIL,
                        `<a class='join-account__email'  href="mailto:${emailField}">${emailField} </a>`
                    )
                    ?.replace(
                        AEM_CONTAINS_PHONE_NUMBER,
                        `<a class='join-account__phone' 
                         href="tel:${phoneNumber}">${phoneNumber}</a>`
                    )
            }}></p>
    );

    const handleJoinAccountModalClose = () => {
        setShowJoinAccountModal(false);
        sendEventsForModalClosed(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CTA_CLICKED,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_CLOSE,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_BUTTON,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_MODAL,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CLOSE
        );
    };

    return (
        <GlobalModal
            className={'width-327'}
            isOpen={showJoinAccountModal}
            onRequestClose={handleJoinAccountModalClose}
            title={joinAccountTitle}
            portalClassName={'gr-join-account-modal'}
            content={modalDescription}
            handleOnAfterOpen={handleOnAfterOpen}
            handleClose={handleJoinAccountModalClose}
        />
    );
};

export default memo(JoinAccount);
